"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalEquipment = void 0;
var react_1 = __importDefault(require("react"));
var ModalEquipment_module_scss_1 = __importDefault(require("./ModalEquipment.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var Svg_1 = require("../svg/Svg");
var ModalEquipment = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = react_1.default.useState(null), car = _b[0], setCar = _b[1];
    var _c = (0, react_redux_1.useSelector)(selectors_1.modalSelector), selectCar = _c.selectCar, equipment = _c.equipment;
    var modalEquipmentState = equipment.modalState;
    var closeModalEquipment = function () {
        dispatch((0, modalSlice_1.closeModal)('equipment'));
    };
    react_1.default.useEffect(function () {
        var carData = selectCar.filter.car.carSelect;
        if (carData && (!car || car.id !== carData.id)) {
            setCar(carData);
        }
    }, [selectCar, car]);
    if (!(car === null || car === void 0 ? void 0 : car.brand))
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "".concat(ModalEquipment_module_scss_1.default.modal_equipment, " ").concat(modalEquipmentState ? ModalEquipment_module_scss_1.default.modal_equipment_active : ''), onClick: closeModalEquipment },
        react_1.default.createElement("div", { className: ModalEquipment_module_scss_1.default.modal_equipment__inner, onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement("header", { className: ModalEquipment_module_scss_1.default.modal_equipment__header },
                react_1.default.createElement("h3", { className: ModalEquipment_module_scss_1.default.modal_equipment__title }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F"),
                react_1.default.createElement("h4", null, car.description),
                react_1.default.createElement(Svg_1.Cross, { className: ModalEquipment_module_scss_1.default.modal_equipment__cross, handler: closeModalEquipment })),
            react_1.default.createElement("div", { className: ModalEquipment_module_scss_1.default.modal_equipment__content },
                react_1.default.createElement("ul", { className: ModalEquipment_module_scss_1.default.modal_equipment__category_list }, (car === null || car === void 0 ? void 0 : car.extras) && ((_a = car === null || car === void 0 ? void 0 : car.extras) === null || _a === void 0 ? void 0 : _a.length)
                    ? car.extras.map(function (category) {
                        return (react_1.default.createElement("li", { className: ModalEquipment_module_scss_1.default.modal_equipment__category_item, key: category.category },
                            react_1.default.createElement("div", null, category.category),
                            react_1.default.createElement("ul", { className: ModalEquipment_module_scss_1.default.modal_equipment__name_list }, category.names.map(function (item) {
                                return (react_1.default.createElement("li", { className: ModalEquipment_module_scss_1.default.modal_equipment__name_item, key: item }, item));
                            }))));
                    })
                    : 'Нет данных')))));
};
exports.ModalEquipment = ModalEquipment;
